import * as React from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { RadioGroupItem } from '@/components/ui/radio-group';

const FormRadio = React.forwardRef(({ className, label, id, ...props }, ref) => {
  const compId = React.useId();

  return (
    <div className={cn('flex items-start gap-2', className)}>
      <RadioGroupItem
        id={id ?? compId}
        ref={ref}
        {...props}
      />
      {label && (
        <Label
          htmlFor={id ?? compId}
          className="font-light text-primary-dark leading-4"
        >
          {label}
        </Label>
      )}
    </div>
  );
});
FormRadio.displayName = 'FormRadio';

export { FormRadio };
